var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarHazardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.481.604c.135.14.246.342.353.506l6.942,12.542c.66,1.262-.205,2.84-1.61,2.991H1.832c-1.34-.164-2.184-1.547-1.688-2.816L7.314.867c.699-1.042,2.298-1.163,3.166-.263ZM8.503,1.535L1.419,14.286c-.227.468.031.958.553,1.006h14.052c.527-.048.778-.537.553-1.005-2.382-4.257-4.7-8.557-7.113-12.793-.289-.264-.7-.251-.96.041Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.822,4.936c.413-.077.784.148.852.57l-.003,4.728c-.164.772-1.245.729-1.349-.054l.002-4.701c.066-.229.25-.498.498-.544Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.001,
    cy: 13.04,
    r: 0.902
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHazardIcon);
export default __webpack_public_path__ + "static/media/Sidebar_HazardIcon.ff33f49064b3e053f8d68fbf82e14f07.svg";
export { ForwardRef as ReactComponent };